import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { _axios } from "../../plugins/axios";
import { WebcamCapture } from "../common/camera";
import { URL, USER, ABHIErId, merCompulsoryPackage, platformsSupportedForPhleboUpsell } from "../../constants/constant";
import BarCodeModal from "../Order/barcode";
import ToasterComponent from "../common/toaster";
import { geolocated } from "react-geolocated";
import watermark, { text } from "watermarkjs";
import { Form, Modal } from "react-bootstrap";
import FileUploadModal from "../Order/fileUpload";
import PackageDetails from "../common/packageDetails";
import AddMerData from "../collectMerData/AddMerData";
import DependantHeaderSample from "../common/dependantHeaderSample";
import DependantEditCustomer from "../common/dependantUpdateCustomer";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { UserLoginDialog } from "../newUpsell/userLoginDialog";
import { Backdrop, CircularProgress } from "@mui/material";

class DependantOrderCollection extends Component {
  constructor(props) {
    super(props);
    console.log(this.props);
    this.myRef = React.createRef();
    this.state = {
      userdata: USER.user,
      orderStatus: null,
      orderDetails: null,
      cameraToggle: false,
      takingSampleForTestId: null,
      messageSnack: "",
      showSnack: false,
      testDetails: [],
      membersDetails: this.props.location.state
        ? this.props.location.state.membersData
        : localStorage.getItem("upsellMemberDetailsConfirm")
        ? JSON.parse(localStorage.getItem("upsellMemberDetailsConfirm"))
        : [],
      upsellMemberDetailsConfirm: localStorage.getItem("upsellMemberDetailsConfirm") ? false : true,
      showSampleCollected: true,
      modalShow: false,
      fileUploadModalShow: false,
      selectedSample: null,
      updateShow: false,
      latitude: "0.0",
      longitude: "0.0",
      reassignLab: false,
      labAssigned: false,
      labId: null,
      labCentersAvailable: [],
      showPackageInfo: false,
      loadPackageDetails: false,
      allOrders: [],
      bulkSelectedSampleCollectedModal: false,
      bulkSelectedSampleCollectedUpdate: [],
      isMerFormDataRequired: false,
      isABHI: false,
      merFormDataCollected: false,
      showMerForm: false,
      dependantId: this.props.match.params.dependantId.toString(),
      rejectRemarkRequired: false,
      isSaveChangesEnabled: false,
      sampleCollectionMarkModal: false,
      sampleImageDetail: {
        cameraToggle: false,
        b64: null,
        imageUploaded: null,
        barcode: null,
      },
      reason: null,
      comment: null,
      options: [],
      openOrderCreationPopup: false,
      isPPMC: false,
      isLoading: false,
      latlongEventTriggerFunction: (ev) => {
        const that = this;
        console.log("lat long received event triggered", ev.detail);

        if (ev.detail !== null && ev.detail !== undefined) {
          const latlong = ev.detail.split(",");
          console.log("lat long split in an arr ", latlong);
          if (latlong !== null && latlong !== undefined) {
            this.state.latitude = latlong[0];
            this.state.longitude = latlong[1];

            that.markOrderSampleCollected();
          } else {
            that.showSnackbarFun("Location not received1, cannot continue", 2500);
          }
        } else {
          that.showSnackbarFun("Location not received, cannot continue", 2500);
        }
        ev.stopImmediatePropagation();
      },
    };
  }

  addEventListeners() {
    if (typeof android !== "undefined" && android !== null) {
      window.addEventListener("setLatLongFromApp", this.state.latlongEventTriggerFunction);
      console.log("addEventListeners : ", this.state.latlongEventTriggerFunction);
    }
  }

  showPackageInfoModal(appointmentId, testName) {
    this.setState({
      showPackageInfo: !this.state.showPackageInfo,
      appointmentIdToGetPackageDetails: appointmentId,
      nameOfTestToGetPackageDetails: testName,
    });
  }

  cleanupListener() {
    if (typeof android !== "undefined" && android !== null) {
      window.removeEventListener("setLatLongFromApp", this.state.latlongEventTriggerFunction);
      console.log("cleanupListener : ", this.state.latlongEventTriggerFunction);
    }
  }

  componentDidMount() {
    this.addEventListeners();
    this.getOrderDetails();
    setTimeout(() => {
      if (this.state.orderDetails?.pendingOrders[0].aadharMandatory) {
        this.showAlert("Please update aadhar and patient details to move forward", 2500);
      }
    }, 1000);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.selectedSample != this.state.selectedSample &&
      this.state.updateShow === false &&
      prevState.modalShow === this.state.modalShow &&
      prevState.fileUploadModalShow === this.state.fileUploadModalShow
    ) {
      console.log("Update the page!!");
      this.addEventListeners();
      this.getOrderDetails();
    }
  }

  componentWillUnmount() {
    this.cleanupListener();
  }

  showSnackbarFun(message, timeout) {
    this.setState(
      {
        messageSnacks: message,
        showSnackbar: true,
      },
      () => {
        this.toastComponent();
      }
    );
    setTimeout(() => {
      this.setState({
        messageSnacks: "",
        showSnackbar: false,
      });
    }, timeout);
  }

  showdisabledButton() {
    this.setState({
      showSampleCollected: true,
    });

    let sampleImageDetails = this.state.sampleImageDetail;
    let testDetailsTempImageUploaded = true;

    if (!sampleImageDetails.imageUploaded) {
      testDetailsTempImageUploaded = false;
    }
    if (sampleImageDetails.barcode == null) {
      testDetailsTempImageUploaded = false;
    }

    if (testDetailsTempImageUploaded && (this.state.isMerFormDataRequired ? this.state.merFormDataCollected : true)) {
      this.setState({
        showSampleCollected: false,
      });
    }
  }

  showAlert(message, timeout) {
    this.setState({
      messageSnack: message,
      showSnack: true,
    });
    setTimeout(() => {
      this.setState({
        messageSnack: "",
        showSnack: false,
      });
    }, timeout);
  }

  callbackForCollection = (result) => {
    this.showAlert(result.message, 2500);
    this.addEventListeners();
    this.setState({
      dependantId: result.orders[0].dependantId
    });
    this.getOrderDetails();
  };

  onEditCustomer() {
    this.setState({ updateShow: true });
  }

  navigateToReschedule(id, time, reqId, city, DID, providerOrderId, name) {
    localStorage.setItem("AppointmentDate", JSON.stringify(time));
    localStorage.setItem("AppointmentId", JSON.stringify(reqId));
    localStorage.setItem("City", JSON.stringify(city));
    localStorage.setItem("DID", JSON.stringify(DID));
    localStorage.setItem("providerOrderId", JSON.stringify(providerOrderId));
    localStorage.setItem("name", JSON.stringify(name));
    let routerLink = "/dependantSample/collected/Reschedule/" + DID;
    this.props.history.push(routerLink);
  }

  getOrderDetails() {
    const that = this;
    let dependantId = this.state.dependantId;
    let url = URL.dev_url;
    let route = url + "getorders";
    let obj = {
      phleboId: this.state.userdata.phleboId,
      dependantId: dependantId,
    };

    _axios
      .post(route, obj)
      .then(function (response) {
        let filteredOrder = { ...response.data };
        localStorage.setItem("order_details", JSON.stringify(response.data));
        localStorage.setItem("customer_phoneNumber", response.data.pendingOrders[0].patientDetails[0].phoneNumber);
        let testDetails = filteredOrder ? filteredOrder.pendingOrders?.flatMap((order) => order.tests) : null;
        let ppmcTest = testDetails && testDetails.length ? testDetails.filter((item) => item.testType == "PPMC").length > 0 : false;
        that.setState({
          loadPackageDetails: true,
          orderDetails: filteredOrder,
          allOrders: response.data.pendingOrders,
          testDetails: testDetails,
          isMerFormDataRequired:
            filteredOrder &&
            (ABHIErId.includes(filteredOrder.pendingOrders[0]?.patientDetails?.[0]?.entityRelationId) ||
              testDetails.filter((item) => merCompulsoryPackage.includes(item.testId)).length > 0)
              ? true
              : false,
          isABHI: filteredOrder && ABHIErId.includes(filteredOrder.pendingOrders[0]?.patientDetails?.[0]?.entityRelationId) ? true : false,
          isPPMC: ppmcTest,
        });

        const city = response.data?.pendingOrders?.[0]?.patientDetails?.[0]?.city ?? USER.user.city;
        const mbCodes = testDetails?.map(t => t.testId) ?? [];

        that.getAvailableLabCenters(city, mbCodes);

        that.setState({
          labAssigned: !!filteredOrder?.pendingOrders?.every(p => p.labDetails?.AssignedLabId),
        });
      })
      .catch(function (error) {
        console.log(error);
        
        that.setState({
          labAssigned: false
        });
      });
  }

  getAvailableLabCenters(city, mbCodes) {
    const that = this;

    that.setState({
      isLoading: true,
    });

    const url = 
      `${URL.OMS}/oms/serving-spcs?cities=${city}&mbCodes=${mbCodes.join()}`

    _axios
      .get(url)
      .then(function (res) {
        that.setState({
          isLoading: false,
          labCentersAvailable: res.data,
        });
      })
      .catch(function (err) {
        console.log(err);
        that.setState({
          isLoading: false,
        });
      });
  }

  callbackForBarCode = (sampleValues) => {
    this.setState(
      {
        sampleImageDetail: sampleValues,
      },
      () => {
        this.showdisabledButton();
      }
    );
  };

  handleCameraToggle() {
    const that = this;
    let sampleImageDetails = {};
    sampleImageDetails["cameraToggle"] = true;

    this.setState(
      {
        sampleImageDetail: sampleImageDetails,
      },
      () => {
        that.checkCamera();
      }
    );
  }

  callback = async (sampleValues) => {
    // do something with value in parent component, like save to state
    this.setState(
      {
        sampleImageDetail: sampleValues,
      },
      () => {
        this.showdisabledButton();
      }
    );
  };

  checkCamera() {
    if (this.state.sampleImageDetail) {
      let sampleImageDetails = this.state.sampleImageDetail;

      if (!sampleImageDetails.imageUploaded) {
        if (sampleImageDetails.cameraToggle)
          return (
            <WebcamCapture multipleImages={true} cameraFace="environment" dataParentToChild={sampleImageDetails} parentCallback={this.callback} />
          );
      }
    }
  }
  getOptions() {
    const that = this;
    if (this.state.options.length > 0) {
      return;
    }
    _axios.get(URL.dev_url + "getAllRejectionReasons", { params: { visibleInRetool: 0, visibleInRunnrApp: 1 } }).then(function (res) {
      let options = [];
      res.data.reasons.forEach((i) => {
        let obj = {
          value: "",
          label: "",
        };

        obj.value = i.reason;
        obj.label = i.reason;

        options.push(obj);
      });

      that.setState({
        options: options,
      });
    });
  }
  handleLabCenterChange(event) {
    event.preventDefault();
    this.setState({ labId: event.target.value });
  }

  updateLabCenter(val) {
    let dependantId = this.state.dependantId;

    const that = this;
    if (!this.state.labId) {
      this.showSnackbarFun("Please select lab center", 3000);
      return;
    }
    let route = URL.dev_url + "updateSPCForOrderId";
    _axios
      .post(route, {
        dependantId: dependantId,
        spcId: this.state.labId || val,
        executeAtPatientLevel: true,
      })
      .then(function (res) {
        that.getOrderDetails();
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  redirectToCollectVitals() {
    localStorage.setItem("orderTestDetails", JSON.stringify(this.state.testDetails));
    let x = "/collect/vitals/" + parseInt(this.state.orderDetails.pendingOrders[0].prOrderId);
    this.props.history.push(x);
  }

  async uploadImageToS3(name, url) {
    var url = url + "";
    var arr = url.split(",");
    var mime = arr[0].match(/:(.*?);/)[1];
    var bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    console.log(u8arr);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    var p = new File([u8arr], name, { type: mime }); // send this file

    var data = new FormData();
    data.append("FileName", name?.split(".")[0]);
    data.append("File", p);
    data.append("FileExtension", "jpeg");

    var config = {
      method: "post",
      url: "https://oms.medibuddy.in/oms/uploadFile",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: data,
    };

    const response = await _axios(config);
    let guid = Object.keys(response.data.file)[0];
    return guid;
  }
  async redirectOtpCustomer() {
    // Phlebo Reached Patients home
    if (this.state.orderDetails.pendingOrders[0].aadharMandatory) {
      console.log(this.state.orderDetails);
      setTimeout(() => {
        this.myRef.current.scrollIntoView({ behavior: "smooth" });
      }, 500);
    } else {
      if (typeof android !== "undefined" && android !== null) {
        console.log("Checking location in android");
        android.startLocationTracking();
      } else {
        if (!(this.props.isGeolocationAvailable && this.props.isGeolocationEnabled)) {
          this.showSnackbarFun("Geolocation not available/enabled, Please give permissions", 4500);
        } else if (this.props.coords != undefined && this.props.coords != null && this.props.coords != "") {
          this.state.longitude = this.props.coords.longitude;
          this.state.latitude = this.props.coords.latitude;
        }

        //marking order sample collected from react web app even if we don't have location coords
        this.markOrderSampleCollected();
      }
    }
  }

  async markOrderSampleCollected() {
    const that = this;

    that.setState({
      isLoading: true,
    });

    let SampleGuids = [];
    let barCodesTestDetails = [];
    if (this.state.sampleImageDetail.imageUploaded) {
      for (let k = 0; k < this.state.sampleImageDetail.b64.length; k++) {
        await watermark([this.state.sampleImageDetail.b64[k]])
          .image(
            text.lowerLeft(
              `Dependant# ${this.state.dependantId} AT: ${parseFloat(this.state.latitude).toFixed(4)}, ${parseFloat(this.state.longitude).toFixed(
                4
              )}`,
              "48px",
              "#fff",
              0.9
            )
          )
          .render()
          .image(text.upperLeft(`Time: ${new Date()}`, "48px", "#fff", 0.9))
          .then(async (img) => {
            let name = this.state.sampleImageDetail.barcode + k + ".jpeg";
            let guid = await this.uploadImageToS3(name, img.currentSrc);
            SampleGuids.push(guid);
          })
          .catch((error) => {
            that.setState({
              isLoading: false,
            });

            throw error;
          });
      }
    }
    barCodesTestDetails.push(this.state.sampleImageDetail.barcode);

    this.setState({
      SampleGuids: SampleGuids,
      barCodesTestDetails: barCodesTestDetails,
    });
    let url = URL.dev_url;
    let route = url + "bulkUpdateOrders";
    let obj;
    let allRequestBodies = [];
    for (let order of this.state.orderDetails.pendingOrders) {
      if (order.sampleCollected) {
        obj = {
          access_token: "trialTest" || USER.access_token,
          currentStatusId: 4,
          requestNextStatusId: 5,
          phleboId: this.state.userdata.phleboId,
          orderId: order.orderId,
          SampleGuids: SampleGuids,
          customerBarcodeArr: barCodesTestDetails,
          lat: parseFloat(this.state.latitude).toFixed(4).toString(),
          long: parseFloat(this.state.longitude).toFixed(4).toString(),
        };
        allRequestBodies.push(obj);
      } else if (order.sampleRejected) {
        obj = {
          access_token: "trialTest" || USER.access_token,
          currentStatusId: 3,
          requestNextStatusId: 31,
          phleboId: this.state.userdata.phleboId,
          orderId: order.orderId,
          rescheduleComment: this.state.comment,
        };
        allRequestBodies.push(obj);
      }
    }
    _axios
      .post(route, {
        allRequestBodies: allRequestBodies,
      })
      .then(function (response) {
        console.log("response", response.data);
        if (response.data.success) {
          localStorage.removeItem("upsellMemberDetailsConfirm");
          localStorage.removeItem("upsellOrderIds");
          that.setState({
            sampleCollectionMarkModal: false,
            bulkSelectedUpsellPitchModal: true,
          });
        }
        that.setState({
          isLoading: false,
        });
      })
      .catch(function (error) {
        console.log(error);
        that.setState({
          isLoading: false,
        });
      });
  }

  routeToCancelPage() {
    let x = "/dependantCancel/" + this.state.dependantId;
    this.props.history.push(x);
  }

  toastComponent() {
    return (
      <ToasterComponent
        show={this.state.showSnackbar ? this.state.showSnackbar : ""}
        message={this.state.messageSnacks ? this.state.messageSnacks : ""}
      ></ToasterComponent>
    );
  }

  TriggerLinkValidation() {
    if (
      this.state.testDetails &&
      this.state.testDetails.length > 0 &&
      this.state.orderDetails?.pendingOrders[0]?.patientDetails[0]?.corporateName?.toLowerCase().includes("tata aia")
    ) {
      let ismer = false;
      for (let i = 0; i < this.state.testDetails.length; i++) {
        if(this.state.testDetails[i].testName.includes("PPMC Details : ")) {
          let tests = this.state.testDetails[i].testName.split("PPMC Details : ")[1].split(",");
          let merArray = ["ME", "MER", "MER with RUA", "Medical Examination Report"];
          if (tests) {
            for (let elem of tests) {
              if (merArray.includes(elem)) {
                ismer = true;
              }
            }
          }
        }
      }
      return ismer;
    }
  }

  redirectToCollectMerData() {
    this.setState({
      showMerForm: true,
    });
  }

  handleGoBackFromMer = (isMerFormCollected) => {
    this.setState({
      showMerForm: false,
      merFormDataCollected: isMerFormCollected,
    });
    this.showdisabledButton();
  };

  markBulkSampleCollectedOrRejected = (orderId, status) => {
    let orders = this.state.orderDetails;
    let order = orders.pendingOrders.find((order) => order.orderId == orderId);
    let rejectRemarkRequired = this.state.rejectRemarkRequired;
    let isSaveChangesEnabled = this.state.isSaveChangesEnabled;
    if (status == 1) {
      order.sampleCollected = true;
      order.sampleRejected = false;
    } else if (status == 2) {
      order.sampleRejected = true;
      order.sampleCollected = false;
    }
    order.isSelected = true;
    let rejectedOrders = orders.pendingOrders.filter((order) => order.sampleRejected);
    let selectedOrders = this.state.orderDetails.pendingOrders.filter((order) => order.isSelected);
    if (rejectedOrders.length) {
      rejectRemarkRequired = true;
    } else {
      rejectRemarkRequired = false;
    }
    if (selectedOrders.length == this.state.orderDetails.pendingOrders.length) {
      isSaveChangesEnabled = rejectRemarkRequired ? this.state.comment : true;
    } else {
      isSaveChangesEnabled = false;
    }
    this.setState({
      orderDetails: orders,
      rejectRemarkRequired: rejectRemarkRequired,
      isSaveChangesEnabled: isSaveChangesEnabled,
    });
  };

  openBulkSampleCollectedPopup = () => {
    this.setState({ sampleCollectionMarkModal: true });
    this.getOptions();
  };

  switchReason(reason) {
    let commentPresent;
    if (!reason.value.includes("Reschedule") && !reason.value.includes("reschedule") && reason.value !== "Other") {
      this.setState({
        comment: reason.value,
        reason: reason.value,
      });
      commentPresent = true;
    } else {
      this.setState({
        comment: null,
        reason: reason.value,
        date: null,
      });
      commentPresent = false;
    }
    let isSaveChangesEnabled = this.state.isSaveChangesEnabled;
    let selectedOrders = this.state.orderDetails.pendingOrders.filter((order) => order.isSelected);
    if (selectedOrders.length == this.state.orderDetails.pendingOrders.length) {
      isSaveChangesEnabled = this.state.rejectRemarkRequired ? commentPresent : true;
    } else {
      isSaveChangesEnabled = false;
    }
    this.setState({
      isSaveChangesEnabled: isSaveChangesEnabled,
    });
  }
  setStartDate(date) {
    let reason = this.state.reason.concat(" ");
    const newDate = date.toLocaleString();

    let reasonWithDate = reason.concat(newDate);

    this.setState({
      date: date,
    });

    this.setState({
      comment: reasonWithDate,
    });
    let isSaveChangesEnabled = this.state.isSaveChangesEnabled;
    let selectedOrders = this.state.orderDetails.pendingOrders.filter((order) => order.isSelected);
    if (selectedOrders.length == this.state.orderDetails.pendingOrders.length) {
      isSaveChangesEnabled = true;
    } else {
      isSaveChangesEnabled = false;
    }
    this.setState({
      isSaveChangesEnabled: isSaveChangesEnabled,
    });
  }

  addMoreTests() {
    localStorage.removeItem("userName")
    localStorage.removeItem("selectedBenef")
    localStorage.removeItem("cart")
    localStorage.removeItem("user_short_token")
    localStorage.removeItem("parentOrderDetails")
    let parentOrderDetails = { ...this.state.orderDetails.pendingOrders[0].patientDetails[0], orderDateTime: this.state.orderDetails.pendingOrders[0].orderDateTime, orderId: this.state.orderDetails.pendingOrders[0].prOrderId}
    localStorage.setItem("parentOrderDetails", JSON.stringify(parentOrderDetails))
    localStorage.setItem("userName", this.state.orderDetails?.pendingOrders?.[0]?.patientDetails?.[0]?.userName)
    this.setState( {openOrderCreationPopup: true} );
  }


  redirectToSmartCareUpsell() {
    this.setState({
      isLoading: true,
    });
    const getPhleboDeails = JSON.parse(localStorage.getItem("user_details"));
    window.location.href = `https://healthverse.medibuddy.in/smartcare?phleboid=${getPhleboDeails.phleboId}&username=${this.state.orderDetails?.pendingOrders?.[0]?.patientDetails?.[0]?.userName}&orderid=${this.state.orderDetails.pendingOrders[0].prOrderId}`
  }

  render() {
    return this.state.showMerForm ? (
      <AddMerData
        filteredOrders={this.state.orderDetails}
        isABHI={this.state.isABHI}
        handleGoBackFromMer={(isMerFormCollected) => this.handleGoBackFromMer(isMerFormCollected)}
      />
    ) : (
      <div ref={this.myRef}>
        <Backdrop open={this.state.isLoading} sx={{ zIndex: 99999 }}>
          <CircularProgress />
        </Backdrop>
        <Modal
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.sampleCollectionMarkModal}
          onHide={() => {
            this.setState({ sampleCollectionMarkModal: false });
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Select sample collected or rejected for all orders of {this.state.orderDetails?.pendingOrders?.[0]?.patientDetails?.[0]?.name}?
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ padding: "1px", display: "flex", flexDirection: "column", marginTop: "10px" }}>
            <Row style={{ display: "flex", flexDirection: "column", marginLeft: "20px", marginBottom: "50px" }}>
              {this.state.orderDetails &&
                this.state.orderDetails.pendingOrders.map((data) => (
                  <div style={{ marginLeft: "5px", marginRight: "5px" }}>
                    <div>{`${data.tests[0].testName} (#${data.appointmentId})`}</div>
                    <input
                      type="radio"
                      id={data.orderId + "collected"}
                      name={data.orderId}
                      value={data.orderId + "collected"}
                      checked={data.sampleCollected}
                      onChange={(e) => this.markBulkSampleCollectedOrRejected(data.orderId, 1)}
                    />
                    <span className="ml-2">Sample Collected</span>
                    <input
                      className="m-l-10"
                      type="radio"
                      id={data.orderId + "rejected"}
                      name={data.orderId}
                      value={data.orderId + "rejected"}
                      checked={data.sampleRejected}
                      onChange={(e) => this.markBulkSampleCollectedOrRejected(data.orderId, 2)}
                    />
                    <span className="ml-2">Rejected</span>
                  </div>
                ))}
              {this.state.rejectRemarkRequired && (
                <div>
                  <Row className="p-t-10" style={{ width: "350px" }}>
                    <Col xs={12}>
                      <div className="font-size-md bold">Reason: </div>
                      <Select defaultValue={null} isSearchable={true} onChange={(event) => this.switchReason(event)} options={this.state.options} />
                    </Col>
                  </Row>
                  {this.state.reason !== null && (this.state.reason.includes("Reschedule") || this.state.reason.includes("reschedule")) && (
                    <Row className="date-picker p-t-10 m-1">
                      <div className="font-size-ml bold">Pick A Date and Time:</div>
                      <DatePicker
                        selected={this.state.date}
                        onChange={(date) => this.setStartDate(date)}
                        showTimeSelect
                        inputProps={{ readOnly: true }}
                        dateFormat="dd/MM/yyyy HH:mm"
                        className="form-control"
                      />
                    </Row>
                  )}
                </div>
              )}
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={() => this.redirectOtpCustomer()} disabled={!this.state.isSaveChangesEnabled}>
              Save changes
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.bulkSelectedUpsellPitchModal}
          onHide={() => {
            this.setState({ bulkSelectedUpsellPitchModal: false });
          }}
        >
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">Did you convince customer to take upsell tests?</Modal.Title>
          </Modal.Header>
          <Modal.Footer>
            <Button
              variant="danger"
              onClick={() => {
                this.setState({ bulkSelectedUpsellPitchModal: false });
                this.props.history.push("/dependantOtp/customer/" + this.state.dependantId);
              }}
            >
              No
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                this.setState({ bulkSelectedUpsellPitchModal: false });
                this.props.history.push("/dependantOtp/customer/" + this.state.dependantId);
              }}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.showUploadedImage}
          onHide={() => {
            this.setState({ showUploadedImage: false });
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Uploaded Image</Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ padding: "1px", overflowY: "auto", display: "flex", flexDirection: "column", rowGap: "1px", marginTop: "5px" }}>
            <div className="text-align-center">
              <div>
                {this.state.sampleImageDetail.b64
                  ? this.state.sampleImageDetail.b64.map((elem, index) => (
                      <div key={index} className="width-100 text-align-center p-b-10">
                        <img className="width-100 text-align-center p-b-10" src={elem}></img>
                      </div>
                    ))
                  : ""}
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <div className="order-details-dashboard">
          <div>
            <div className="header-sample">
              <i className="fa fa-chevron-circle-left" onClick={() => this.props.history.push('/dependantOrders')}></i>
            </div>
            {this.state.orderDetails ? (
              <DependantHeaderSample
                titleCall={false}
                // props = {this.props}
                orderHeader={this.state.orderDetails.pendingOrders[0]}
                noCall={this.state.orderDetails.pendingOrders[0].noCall}
                onEditCustomer={() => this.onEditCustomer()}
                onRescheduleRoute={(id, time, reqId, city, did, orderId, name) =>
                  this.navigateToReschedule(id, time, reqId, city, did, orderId, name)
                }
              ></DependantHeaderSample>
            ) : (
              ""
            )}
          </div>
          <div>
            <Container>
              <Row>
                <Col xs={12} md={12}>
                  <div className="p-l-10 p-r-10 p-t-10">
                    <Row className="font-size-md bold m-b-5">
                      <Col xs={6} md={6} style={{ display: "flex" }} className="align-items-center">
                        <i className="fa fa-flask m-r-10" aria-hidden="true"></i>
                        Tests
                      </Col>
                      <Col xs={6} md={6} className="text-align-right flex flex-column">
                        <>
                          <Button type="submit" size="sm" style={{ backgroundColor: "#FFD20A", color: "black", border: "none", fontWeight: "bold", marginBottom: "5px", width: "100px" }} onClick={() => this.redirectToSmartCareUpsell()}>Earn More &#8377;</Button>
                        </>
                      </Col>
                    </Row>
                    <div className="font-size-smd">
                      <ol>
                        {this.state.orderDetails
                          ? this.state.orderDetails.pendingOrders.map((order) => {
                              return order.tests.map((elem) => {
                                return (
                                  <li key={elem.testId}>
                                    {`${elem.testName} - ${order.appointmentId}`}
                                    <button className="btn btn-default" onClick={() => this.showPackageInfoModal(order.appointmentId, elem.testName)}>
                                      <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="15px" height="15px">
                                        <path d="M25,2C12.297,2,2,12.297,2,25s10.297,23,23,23s23-10.297,23-23S37.703,2,25,2z M25,11c1.657,0,3,1.343,3,3s-1.343,3-3,3 s-3-1.343-3-3S23.343,11,25,11z M29,38h-2h-4h-2v-2h2V23h-2v-2h2h4v2v13h2V38z" />
                                      </svg>
                                    </button>
                                    {elem.testDetails != null ? (
																			<div className="display-flex justify-content-space-between p-b-10">
																				<div className="break-words">
																					{"Test Details: " + elem.testDetails}
																				</div>
																			</div>
																		) : (
																			<></>
																		)}
                                  </li>
                                );
                              });
                            })
                          : ""}
                      </ol>
                    </div>

                    <div className="p-b-15 display-flex justify-content-space-around">
                      {this.state.orderDetails && platformsSupportedForPhleboUpsell.includes(this.state.orderDetails.pendingOrders[0].platform?.toLowerCase()) && 
                      <Button 
                        type="submit"
                        size="sm" 
                        onClick={() => this.addMoreTests()}
                      >
                        Comprehensve Health Management
                      </Button>}
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={12}>
                  <div className="p-l-10 p-r-10 p-b-10">
                    <div className="font-size-smd bold">
                      <i className="fa fa-map-marker m-r-10 p-b-10" aria-hidden="true"></i>
                      <span>Lab Address</span>
                      <button
                        onClick={() => {
                          this.setState({
                            reassignLab: !this.state.reassignLab,
                          });
                        }}
                        className="btn btn-default btn-sm patientEdit m-b-2"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="15"
                          fill="currentColor"
                          className="bi bi-pencil-square"
                          viewBox="0 0 16 16"
                        >
                          <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                          <path
                            fill-rule="evenodd"
                            d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                          />
                        </svg>
                      </button>
                    </div>
                    <div className="font-size-smd p-l-15">
                      {this.state.labAssigned &&
                      !this.state.reassignLab ? (
                        <>
                          <span> {this.state.orderDetails.pendingOrders[0].labDetails.AssignedLab}, </span>
                          <span> {this.state.orderDetails.pendingOrders[0].labDetails.AssignedLabAddress} </span>
                        </>
                      ) : (
                        <Form onSubmit={(e) => this.updateLabCenter(this.state.labId, e)}>
                          <Form.Group controlId="formGroupSelectLabCenter">
                            <Form.Label>Select a Lab Center</Form.Label>
                            <Form.Control as="select" onChange={(e) => this.handleLabCenterChange(e)}>
                              <option value="">Select</option>
                              {this.state.labCentersAvailable.map((each, idx) => (
                                // {each.labId}
                                <option key={idx} value={each.labId}>
                                  {each.labName + ", " + each.address}
                                </option>
                              ))}
                            </Form.Control>
                          </Form.Group>
                          <Button disabled={!this.state.labId} variant="primary" type="submit" className="text-align-center w-100">
                            Save
                          </Button>
                        </Form>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
            <Container>
              <div className="width-100 p-l-10 p-r-10 p-b-10 display-flex justify-content-space-between">
                <span className="font-size-smd bold p-t-7">Sample Collected</span>
                {!this.state.sampleImageDetail.imageUploaded ? (
                  <button type="button" className="btn btn-outline-info p-1" onClick={() => this.handleCameraToggle()}>
                    <span className="font-size-smd">
                      <i className="fa fa-camera m-r-10" aria-hidden="true"></i>
                      Click Image
                    </span>
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-outline-info p-1"
                    onClick={() => {
                      this.setState({ showUploadedImage: true });
                    }}
                  >
                    View Image
                  </button>
                )}
              </div>
              <div className="width-100 p-l-10 p-r-10 display-flex justify-content-space-between">
                <span className="font-size-smd bold p-t-7">Barcode</span>
                {this.state.sampleImageDetail.barcode ? (
                  <div>
                    <i className="fa fa-barcode font-size-lg p-r-5" aria-hidden="true"></i>
                    <span className="font-size-smd bold">{this.state.sampleImageDetail.barcode}</span>
                  </div>
                ) : (
                  <button type="button" className="btn btn-outline-info p-1" onClick={() => this.setState({ modalShow: true })}>
                    <span className="font-size-smd">
                      <i className="fa fa-search p-r-5" aria-hidden="true"></i>
                      Scan Barcode
                    </span>
                  </button>
                )}
              </div>
            </Container>

            <Container>
              <Row>
                <div className="width-100">{this.checkCamera()}</div>
              </Row>
            </Container>

            {this.state.isPPMC && (
              <div className="display-flex justify-content-space-around m-b-10">
                {this.TriggerLinkValidation() && (
                  <div>
                    <button type="button" className="btn btn-outline-info mt-1" onClick={() => this.setState({ fileUploadModalShow: true })}>
                      <span className="font-size-smd">Trigger Link</span>
                    </button>
                  </div>
                )}

                <div>
                  <button type="button" className="btn btn-outline-info mt-1" onClick={() => this.redirectToCollectVitals()}>
                    <span className="font-size-smd">Collect Vitals</span>
                  </button>
                </div>
              </div>
            )}
            {(!this.state.isPPMC || this.state.isMerFormDataRequired) && (
              <div className="display-flex justify-content-space-around mt-2 m-b-10">
                <div>
                  <button type="button" className="btn btn-outline-info" onClick={() => this.redirectToCollectMerData()}>
                    <span className="font-size-smd">Collect MER Data</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        <div>
          <Container>
            <div className="fixed-bottom p-l-15 p-r-15 p-t-5 p-b-5">
              <Row>
                <Col xs={6} md={6}>
                    <Button variant="primary" size="md" block className="border-curve-10" onClick={() => this.routeToCancelPage()}>
                      Reject
                    </Button>
                </Col>

                <Col xs={6} md={6}>
                      <Button
                        variant="primary"
                        size="md"
                        block
                        className="border-curve-10"
                        disabled={this.state.showSampleCollected || !this.state.labAssigned}
                        onClick={() => this.openBulkSampleCollectedPopup()}
                      >
                        Sample Collected
                      </Button>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        {this.state.fileUploadModalShow && (
          <FileUploadModal
            vendor={this.state.orderDetails?.pendingOrders[0]?.patientDetails[0]?.corporateName}
            applicationid={this.state.orderDetails.pendingOrders[0].patientDetails[0].employeeId}
            show={this.state.fileUploadModalShow}
            onHide={() => this.setState({ fileUploadModalShow: false })}
          />
        )}
        {this.state.modalShow && (
          <BarCodeModal
            show={this.state.modalShow}
            dataparenttochild={this.state.sampleImageDetail}
            parentCallback={(result) => this.callbackForBarCode(result)}
            onHide={() => this.setState({ modalShow: false })}
          />
        )}
        {this.state.showSnack ? <div className="snackbar2 show">{this.state.messageSnack}</div> : ""}
        {this.state.updateShow && (
          <DependantEditCustomer
            show={this.state.updateShow}
            dataparenttochild={this.state.orderDetails.pendingOrders[0]}
            parentCallback={(result) => this.callbackForCollection(result)}
            isPPMC={this.state.isPPMC}
            props={this.props}
            onHide={() => this.setState({ updateShow: false })}
          />
        )}
        {this.state.showPackageInfo && (
          <PackageDetails
            showPackageInfo={this.state.showPackageInfo}
            showPackageInfoModal={() => this.showPackageInfoModal()}
            appointmentId={this.state.appointmentIdToGetPackageDetails}
            packageName={this.state.nameOfTestToGetPackageDetails}
          />
        )}
        {this.state.openOrderCreationPopup && (
          <UserLoginDialog
            userName={this.state.orderDetails?.pendingOrders?.[0]?.patientDetails?.[0]?.userName}
            getControl={(status) => this.setState({ openOrderCreationPopup: status })}
            errorAlert={(err) => err && alert(err)}
          />
        )}
      </div>
    );
  }
}
export default geolocated({
  positionOptions: {
    enableHighAccuracy: true,
  },
  userDecisionTimeout: 5000,
})(DependantOrderCollection);
